// import User from '@/pages/backend/user/User.vue'
// import Edit from '@/pages/backend/edit/Edit.vue'
// import Design from '@/pages/backend/design/Design.vue'
import UserRouter from '@/router/backend/user/index.js'
const User = () => import('@/pages/backend/user/User.vue')
const Edit = () => import('@/pages/backend/edit/Edit.vue')
const Design = () => import('@/pages/backend/design/Design.vue')

export default [
  {
    path: '/backend',
    name: '后台管理',
    redirect: '/backend/user'
  },
  {
    path: '/backend/user',
    name: '基础操作',
    component: User,
    children: [...UserRouter]
  },
  {
    path: '/backend/edit',
    name: '编辑操作',
    component: Edit
  },
  {
    path: '/backend/design',
    name: '设计操作',
    component: Design
  }
]



// WEBPACK FOOTER //
// ./src/router/backend/index.js